import Markdown from '@/common/atoms/Markdown'
import {
  Box,
  FormControl,
  FormLabel,
  Heading,
  Text,
  Textarea,
  VStack,
} from '@chakra-ui/react'
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { SummaryPiece } from '../meetingSummaryShareBoard'
import MeetingSummaryPieceFacts from './MeetingSummaryPieceFacts'

interface Props {
  intro: string
  onChangeIntro(intro: string): void
  // The pieces that will be sent, with their final text
  pieces: SummaryPiece[]
  recipientsNames: string[]
}

// Step 3: the circle's introduction, then what the recipients will read
export default function MeetingSummarySharePreview({
  intro,
  onChangeIntro,
  pieces,
  recipientsNames,
}: Props) {
  const { t } = useTranslation()

  return (
    <VStack spacing={5} align="stretch">
      <FormControl>
        <FormLabel>{t('MeetingSummaryShareModal.intro')}</FormLabel>
        <Textarea
          value={intro}
          placeholder={t('MeetingSummaryShareModal.introPlaceholder')}
          onChange={(event) => onChangeIntro(event.target.value)}
        />
      </FormControl>

      <Box borderWidth={1} borderRadius="md" p={4}>
        <Text fontSize="sm" color="gray.500" _dark={{ color: 'gray.300' }}>
          {t('MeetingSummaryShareModal.sharedWith', {
            names: recipientsNames.join(', '),
          })}
        </Text>
        {intro.trim() && (
          <Box mt={3}>
            <Markdown>{intro}</Markdown>
          </Box>
        )}
        {pieces.map((piece, i) => (
          <Fragment key={piece.id}>
            {piece.section && piece.section !== pieces[i - 1]?.section && (
              <Heading as="h3" size="sm" mt={5}>
                {piece.section}
              </Heading>
            )}
            <Text fontWeight="bold" mt={3}>
              {piece.title}
            </Text>
            <MeetingSummaryPieceFacts piece={piece} />
            {piece.body && <Markdown>{piece.body}</Markdown>}
          </Fragment>
        ))}
      </Box>
    </VStack>
  )
}
